(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-builder"] && !Shopify.designMode) return;
  try {
    

(() => {

  /*
   * Prevent duplicate initialization when Shopify
   * dynamically reloads the section in the theme editor.
   */

  const builders =
    document.querySelectorAll(
      '[data-bundle-builder]'
    );


  if (!builders.length) {
    return;
  }


  builders.forEach((builder) => {

    if (
      builder.dataset.initialized === 'true'
    ) {
      return;
    }


    builder.dataset.initialized = 'true';


    /* =====================================================
       BUNDLE RULES
       ===================================================== */

    const tiers = [
      {
        quantity: 5,
        discount: 5
      },
      {
        quantity: 10,
        discount: 7.5
      },
      {
        quantity: 15,
        discount: 10
      },
      {
        quantity: 20,
        discount: 12.5
      }
    ];


    const maximumBundleQuantity = 20;


    /* =====================================================
       PRODUCT DATA
       ===================================================== */

    const products = {};


    builder
      .querySelectorAll(
        '[data-product-card]'
      )
      .forEach((card) => {

        const variantId =
          String(
            card.dataset.variantId
          );


        products[variantId] = {

          variantId,

          productId:
            card.dataset.productId,

          title:
            card.dataset.title,

          price:
            Number(
              card.dataset.price
            ),

          available:
            card.dataset.available === 'true',

          inventoryManaged:
            card.dataset.inventoryManaged === 'true',

          inventoryQuantity:
            Number(
              card.dataset.inventoryQuantity || 0
            ),

          inventoryPolicy:
            card.dataset.inventoryPolicy,

          image:
            card.querySelector('img')?.src || '',

          quantity: 0,

          card

        };

      });


    /* =====================================================
       ELEMENTS
       ===================================================== */

    const countElement =
      builder.querySelector(
        '[data-bundle-count]'
      );


    const messageElement =
      builder.querySelector(
        '[data-bundle-message]'
      );


    const selectedItemsElement =
      builder.querySelector(
        '[data-selected-items]'
      );


    const subtotalElement =
      builder.querySelector(
        '[data-subtotal]'
      );


    const discountElement =
      builder.querySelector(
        '[data-discount]'
      );


    const totalElement =
      builder.querySelector(
        '[data-total]'
      );


    const progressFill =
      builder.querySelector(
        '[data-progress-fill]'
      );


    const addButton =
      builder.querySelector(
        '[data-add-bundle]'
      );


    const errorElement =
      builder.querySelector(
        '[data-bundle-error]'
      );


    const tierButtons =
      builder.querySelectorAll(
        '[data-tier]'
      );


    const progressDots =
      builder.querySelectorAll(
        '[data-progress-dot]'
      );


    /* =====================================================
       MONEY
       ===================================================== */

    const moneyFormat = builder.dataset.moneyFormat;


    function formatMoney(cents) {

      if (
        window.Shopify &&
        typeof window.Shopify.formatMoney === 'function'
      ) {

        return window.Shopify.formatMoney(
          cents,
          moneyFormat
        );

      }


      return (
        Number(cents) / 100
      ).toFixed(2);

    }


    /* =====================================================
       TOTAL QUANTITY
       ===================================================== */

    function getItemCount() {

      return Object.values(products)
        .reduce(
          (total, product) =>
            total + product.quantity,
          0
        );

    }


    /* =====================================================
       CURRENT DISCOUNT TIER
       ===================================================== */

    function getCurrentTier() {

      const count =
        getItemCount();


      let currentTier = null;


      tiers.forEach((tier) => {

        if (
          count >= tier.quantity
        ) {

          currentTier = tier;

        }

      });


      return currentTier;

    }


    /* =====================================================
       NEXT DISCOUNT TIER
       ===================================================== */

    function getNextTier() {

      const count =
        getItemCount();


      return tiers.find(
        (tier) =>
          count < tier.quantity
      ) || null;

    }


    /* =====================================================
       INVENTORY
       ===================================================== */

    function getMaximumQuantity(product) {

      /*
       * If Shopify manages inventory and
       * inventory policy is "deny", respect
       * the available inventory.
       */

      if (
        product.inventoryManaged &&
        product.inventoryPolicy === 'deny'
      ) {

        return Math.max(
          0,
          product.inventoryQuantity
        );

      }


      /*
       * If inventory can continue selling,
       * the storefront doesn't need to
       * restrict the quantity.
       */

      return Infinity;

    }


    /* =====================================================
       UPDATE PRODUCT CARD
       ===================================================== */

    function updateProductCard(product) {

      const quantityElement =
        product.card.querySelector(
          '[data-quantity]'
        );


      const minusButton =
        product.card.querySelector(
          '[data-action="decrease"]'
        );


      const plusButton =
        product.card.querySelector(
          '[data-action="increase"]'
        );


      quantityElement.textContent =
        product.quantity;


      minusButton.disabled =
        product.quantity <= 0;


      const maximumQuantity =
        getMaximumQuantity(
          product
        );


      plusButton.disabled =
        !product.available ||
        product.quantity >= maximumQuantity ||
        getItemCount() >= maximumBundleQuantity;


      product.card.classList.toggle(
        'is-selected',
        product.quantity > 0
      );

    }


    /* =====================================================
       UPDATE SELECTED ITEMS
       ===================================================== */

    function updateSelectedItems() {

      const selectedProducts =
        Object.values(products)
          .filter(
            (product) =>
              product.quantity > 0
          );


      if (
        selectedProducts.length === 0
      ) {

        selectedItemsElement.innerHTML = `
          <div class="bundle-empty">
            Your selected products will appear here.
          </div>
        `;

        return;

      }


      selectedItemsElement.innerHTML =
        selectedProducts
          .map((product) => {

            const lineTotal =
              product.price *
              product.quantity;


            return `
              <div class="bundle-selected-item">

                <img
                  class="bundle-selected-item__image"
                  src="${escapeHtml(product.image)}"
                  alt=""
                  loading="lazy"
                >

                <div>

                  <div class="bundle-selected-item__title">
                    ${escapeHtml(product.title)}
                  </div>

                  <div class="bundle-selected-item__quantity">
                    ×${product.quantity}
                  </div>

                </div>

                <div class="bundle-selected-item__price">
                  ${formatMoney(lineTotal)}
                </div>

              </div>
            `;

          })
          .join('');

    }


    /* =====================================================
       PROGRESS
       ===================================================== */

    function updateProgress() {

      const count =
        getItemCount();


      const cappedCount =
        Math.min(
          count,
          maximumBundleQuantity
        );


      /*
       * 0 items = 0%
       * 5 items = 25%
       * 10 items = 50%
       * 15 items = 75%
       * 20 items = 100%
       */

      const progress =
        (
          cappedCount /
          maximumBundleQuantity
        ) * 100;


      progressFill.style.width =
        `${progress}%`;


      progressDots.forEach(
        (dot) => {

          const tierQuantity =
            Number(
              dot.dataset.progressDot
            );


          dot.classList.toggle(
            'is-active',
            count >= tierQuantity
          );

        }
      );


      tierButtons.forEach(
        (button) => {

          const tierQuantity =
            Number(
              button.dataset.tier
            );


          let active = false;


          if (
            count >= tierQuantity
          ) {

            if (
              tierQuantity === 20
            ) {

              active = true;

            } else {

              const nextTier =
                tiers.find(
                  (tier) =>
                    tier.quantity >
                    tierQuantity
                );


              active =
                !nextTier ||
                count <
                nextTier.quantity;

            }

          }


          button.classList.toggle(
            'is-active',
            active
          );

        }
      );

    }


    /* =====================================================
       STATUS MESSAGE
       ===================================================== */

    function updateStatus() {

      const count =
        getItemCount();


      const currentTier =
        getCurrentTier();


      const nextTier =
        getNextTier();


      countElement.textContent =
        `${count} item${count === 1 ? '' : 's'}`;


      if (count === 0) {

        messageElement.textContent =
          'Add 5 items to start your bundle.';


      } else if (count < 5) {

        const remaining =
          5 - count;


        messageElement.textContent =
          `Add ${remaining} more item${remaining === 1 ? '' : 's'} to unlock 5% off.`;


      } else if (nextTier) {

        const remaining =
          nextTier.quantity -
          count;


        messageElement.textContent =
          `${currentTier.discount}% off unlocked. Add ${remaining} more item${remaining === 1 ? '' : 's'} to unlock ${nextTier.discount}% off.`;


      } else {

        messageElement.textContent =
          'Maximum bundle reached. You unlocked 12.5% off.';

      }


      addButton.disabled =
        count < 5 ||
        count > maximumBundleQuantity;

    }


    /* =====================================================
       TOTALS
       ===================================================== */

    function updateTotals() {

      const count =
        getItemCount();


      const subtotal =
        Object.values(products)
          .reduce(
            (total, product) =>
              total +
              (
                product.price *
                product.quantity
              ),
            0
          );


      const currentTier =
        getCurrentTier();


      const discountPercent =
        currentTier
          ? currentTier.discount
          : 0;


      const discountAmount =
        Math.round(
          subtotal *
          (
            discountPercent /
            100
          )
        );


      const total =
        subtotal -
        discountAmount;


      subtotalElement.textContent =
        count > 0
          ? formatMoney(subtotal)
          : '—';


      discountElement.textContent =
        discountAmount > 0
          ? `−${formatMoney(discountAmount)}`
          : '—';


      totalElement.textContent =
        count > 0
          ? formatMoney(total)
          : '—';

    }


    /* =====================================================
       UPDATE EVERYTHING
       ===================================================== */

    function update() {

      Object.values(products)
        .forEach(
          updateProductCard
        );


      updateSelectedItems();

      updateProgress();

      updateStatus();

      updateTotals();

    }


    /* =====================================================
       CHANGE QUANTITY
       ===================================================== */

    function changeQuantity(
      product,
      amount
    ) {

      const currentCount =
        getItemCount();


      let newQuantity =
        product.quantity +
        amount;


      const maximumQuantity =
        getMaximumQuantity(
          product
        );


      newQuantity =
        Math.max(
          0,
          newQuantity
        );


      if (
        newQuantity >
        maximumQuantity
      ) {

        newQuantity =
          maximumQuantity;

      }


      if (
        amount > 0 &&
        currentCount >=
        maximumBundleQuantity
      ) {

        return;

      }


      product.quantity =
        newQuantity;


      update();

    }


    /* =====================================================
       CLEAR
       ===================================================== */

    function clearBundle() {

      Object.values(products)
        .forEach(
          (product) => {

            product.quantity = 0;

          }
        );


      hideError();

      update();

    }


    /* =====================================================
       ERROR
       ===================================================== */

    function showError(message) {

      errorElement.textContent =
        message;

      errorElement.hidden =
        false;

    }


    function hideError() {

      errorElement.textContent =
        '';

      errorElement.hidden =
        true;

    }


    /* =====================================================
       HTML ESCAPE
       ===================================================== */

    function escapeHtml(value) {

      return String(value)
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#039;');

    }


    /* =====================================================
       BUNDLE ID
       ===================================================== */

    function createBundleId() {

      if (
        window.crypto &&
        typeof window.crypto.randomUUID ===
          'function'
      ) {

        return window.crypto.randomUUID();

      }


      return (
        Date.now().toString(36) +
        Math.random()
          .toString(36)
          .substring(2)
      );

    }


    /* =====================================================
       ADD BUNDLE TO CART
       ===================================================== */

    async function addBundleToCart() {

      const count =
        getItemCount();


      if (count < 5) {

        showError(
          'Please select at least 5 items.'
        );

        return;

      }


      if (
        count >
        maximumBundleQuantity
      ) {

        showError(
          'A bundle can contain a maximum of 20 items.'
        );

        return;

      }


      const currentTier =
        getCurrentTier();


      if (!currentTier) {

        showError(
          'Please select at least 5 items.'
        );

        return;

      }


      hideError();


      addButton.disabled =
        true;

      addButton.textContent =
        'Adding...';


      /*
       * One ID is shared by every product
       * belonging to this bundle.
       *
       * This will allow us to group the
       * products later in the cart.
       */

      const bundleId =
        createBundleId();


      /*
       * IMPORTANT:
       *
       * If the customer selects 7 items,
       * the bundle is still called:
       *
       * Build Your Own Box of 5
       *
       * because 5 is the unlocked tier.
       */

      const bundleTitle =
        `Build Your Own Box of ${currentTier.quantity}`;


      const items =
        Object.values(products)
          .filter(
            (product) =>
              product.quantity > 0
          )
          .map(
            (product) => ({

              id:
                Number(
                  product.variantId
                ),

              quantity:
                product.quantity,

              properties: {

                /*
                 * Private Shopify line properties.
                 * These are used later by the
                 * discount function and cart grouping.
                 */

                _bundle_id:
                  bundleId,

                _bundle_type:
                  'build-your-own-box',

                _bundle_title:
                  bundleTitle,

                _bundle_tier:
                  String(
                    currentTier.quantity
                  )

              }

            })
          );


      try {

        const response =
          await fetch(
            `${window.Shopify.routes.root}cart/add.js`,
            {

              method: 'POST',

              headers: {
                'Content-Type':
                  'application/json',

                'Accept':
                  'application/json'
              },

              body:
                JSON.stringify({
                  items
                })

            }
          );


        const data =
          await response.json();


        if (!response.ok) {

          throw new Error(
            data.description ||
            data.message ||
            'Unable to add your bundle to the cart.'
          );

        }


        /*
         * For now, send the customer to
         * Shopify's cart page.
         *
         * Later we can connect this to
         * your existing cart drawer.
         */

        window.location.href =
          `${window.Shopify.routes.root}cart`;


      } catch (error) {

        console.error(
          'Bundle Builder:',
          error
        );


        showError(
          error.message ||
          'Something went wrong while adding your bundle.'
        );


        addButton.disabled =
          false;

        addButton.textContent =
          'Add Bundle To Cart';

      }

    }


    /* =====================================================
       CLICK HANDLER
       ===================================================== */

    builder.addEventListener(
      'click',
      (event) => {

        /*
         * Quantity buttons
         */

        const quantityButton =
          event.target.closest(
            '[data-action]'
          );


        if (quantityButton) {

          const card =
            quantityButton.closest(
              '[data-product-card]'
            );


          if (!card) {
            return;
          }


          const product =
            products[
              String(
                card.dataset.variantId
              )
            ];


          if (!product) {
            return;
          }


          const action =
            quantityButton.dataset.action;


          changeQuantity(
            product,
            action === 'increase'
              ? 1
              : -1
          );


          return;

        }


        /*
         * Clear button
         */

        const clearButton =
          event.target.closest(
            '[data-clear-bundle]'
          );


        if (clearButton) {

          clearBundle();

          return;

        }


        /*
         * Add to cart
         */

        const addButtonElement =
          event.target.closest(
            '[data-add-bundle]'
          );


        if (addButtonElement) {

          addBundleToCart();

          return;

        }


        /*
         * Tier buttons
         *
         * Clicking a tier doesn't automatically
         * add products. It simply gives the customer
         * feedback about what they need.
         */

        const tierButton =
          event.target.closest(
            '[data-tier]'
          );


        if (tierButton) {

          const targetQuantity =
            Number(
              tierButton.dataset.tier
            );


          const count =
            getItemCount();


          if (
            count >= targetQuantity
          ) {

            return;

          }


          const remaining =
            targetQuantity -
            count;


          let discount =
            0;


          const selectedTier =
            tiers.find(
              (tier) =>
                tier.quantity ===
                targetQuantity
            );


          if (selectedTier) {

            discount =
              selectedTier.discount;

          }


          messageElement.textContent =
            `Add ${remaining} more item${remaining === 1 ? '' : 's'} to unlock ${discount}% off.`;

        }

      }
    );


    /* =====================================================
       INITIAL STATE
       ===================================================== */

    update();

  });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
